'use client';;!function(){try{var e="undefined"!=typeof window?window:"undefined"!=typeof global?global:"undefined"!=typeof globalThis?globalThis:"undefined"!=typeof self?self:{};e._sentryModuleMetadata=e._sentryModuleMetadata||{},e._sentryModuleMetadata[(new e.Error).stack]=Object.assign({},e._sentryModuleMetadata[(new e.Error).stack],{"_sentryBundlerPluginAppKey:synergiefrontends":true});}catch(e){}}();

import { useEffect, useRef, useState } from 'react';

type Props = {
  name: string;
  number: number;
  height: number;
  position?: number;
  delay?: number;
  align?: 'start' | 'center' | 'end';
};

// scss: sandyou.be/stylesheets/components/numberRotate.scss

export default function NumberRotate({ name, number, height, position = 1, delay = 0.2, align = 'center' }: Props) {
  if (number < 0 || number > 9 || position < 1) throw Error('Number or position is illegal');

  const multiplier = 2;
  const arr = Array.from({ length: 10 * position * multiplier }, (_, i) => i % 10);
  const ref = useRef<HTMLDivElement>(null);
  const [isVisibile, setIsVisible] = useState(false);
  const [isTransitioned, setIsTransitioned] = useState(false);
  const [yPosition, setYPosition] = useState(0);

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        setIsVisible(entry.isIntersecting);
      },
      {
        root: null,
        rootMargin: '0px',
        threshold: 0.01,
      }
    );

    if (ref.current) observer.observe(ref.current);

    return () => {
      if (ref.current) observer.unobserve(ref.current);
    };
  }, []);

  useEffect(() => {
    if (!isVisibile) return;
    setYPosition((10 * (position - 1) * multiplier + number) * height);
  }, [isVisibile]);

  return (
    <div
      ref={ref}
      className={`${isTransitioned && (position === 1 ? 'jump1' : 'jump2')} overflow-hidden`}
      style={{
        paddingTop: '7px',
        height: `${height + 16}px`,
        maskImage: 'linear-gradient(to bottom, transparent, black 20%, black 80%, transparent)',
        WebkitMaskImage: 'linear-gradient(to bottom, transparent, black 20%, black 80%, transparent)',
      }}
    >
      <div
        className={`d-flex flex-column align-items-${align}`}
        style={{
          fontSize: `${height}px`,
          transform: `translateY(${-(yPosition + (isTransitioned ? 0 : position === 1 ? 25 : 35))}px)`,
          width: 'fit-content',
          transition: `transform ${isTransitioned ? (position === 1 ? '0.6s' : '0.4s') : '2s'} ${isTransitioned ? 0 : delay}s ${isTransitioned ? 'cubic-bezier(0.25, 0.1, 0.25, 1)' : 'ease-in-out'}`,
        }}
        onTransitionEnd={() => setIsTransitioned(true)}
      >
        {arr.map((char, index) => (
          <span
            key={`${name}-${position}-${index}`}
            style={{ lineHeight: `${height}px`, fontFamily: 'Montserrat', fontWeight: '600', color: '#455A63' }}
            className=""
          >
            {char}
          </span>
        ))}
      </div>
    </div>
  );
}
